import { combineReducers } from 'redux';
import locations from './WPData/reducers';
import currentLocation from './CurrentLocation/reducers';
import listContent from './ListContent/reducers';
import mapSettings from './MapSettings/reducers';
import userLocation from './UserLocation/reducers';
import searchTerm from './SearchTerm/reducers';

export default combineReducers({
    locations,
    currentLocation,
    listContent,
    mapSettings,
    userLocation,
    searchTerm,
});
